import { PRODUCT_TYPES } from '@moal/api'
import { useContext, useState } from 'react'
import 'react-quill/dist/quill.snow.css'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { setPageTitle } from '../../../../utils/utilities'
import {
  CustomerSupport,
  DoNotSell,
  TermsAndConditions,
  PrivacyPolicy
} from '../index'
import Copyright from './Copyright'
import './styles.css'

const OrgGeneral = () => {
  setPageTitle('Content | Org General')

  const { productsService } = useContext(SiteConfigContext)
  const [org, setOrg] = useState(productsService[PRODUCT_TYPES.ORG])

  return (
    <div className="flex flex-col gap-6 pb-6">
      <div className="xl:bg-neutral-200/50 xl:dark:bg-neutral-800/50 p-6">
        <div className="flex flex-col gap-4">
          <h1>Copyright</h1>
          <Copyright theOrg={org} />
        </div>
      </div>
      <div className="xl:bg-neutral-200/50 xl:dark:bg-neutral-800/50 p-6">
        <div className="flex flex-col gap-4">
          <h1>Terms and Conditions</h1>
          <TermsAndConditions />
        </div>
      </div>
      <div className="xl:bg-neutral-200/50 xl:dark:bg-neutral-800/50 p-6">
        <div className="flex flex-col gap-4">
          <h1>Privacy Policy</h1>
          <PrivacyPolicy />
        </div>
      </div>
      <div className="xl:bg-neutral-200/50 xl:dark:bg-neutral-800/50 p-6">
        <div className="flex flex-col gap-4">
          <h1>Do Not Sell</h1>
          <DoNotSell />
        </div>
      </div>
      <div className="xl:bg-neutral-200/50 xl:dark:bg-neutral-800/50 p-6">
        <div className="flex flex-col gap-4">
          <h1>Customer Support</h1>
          <CustomerSupport />
        </div>
      </div>
    </div>
  )
}

export default OrgGeneral
